import React, { useState, useEffect } from 'react';
import { Modal, Button, Row, Col, Container } from 'react-bootstrap';
import InputRange from 'react-input-range';
import 'react-input-range/lib/css/index.css';
import './ModalFiltro.css';

const ModalFiltro = ({ show, onHide, ativos, onApplyFilters }) => {
  const [ativosOriginais] = useState(ativos);
  const [ativosFiltrados, setAtivosFiltrados] = useState([]);
  const [ranges, setRanges] = useState({
    valor_vista: { min: 0, max: 1 },
    valor_inicial_parcela_programada: { min: 0, max: 1 },
    area: { min: 0, max: 1 },
  });
  const [filtros, setFiltros] = useState({
    valor_vista: { min: 0, max: 1 },
    valor_inicial_parcela_programada: { min: 0, max: 1 },
    area: { min: 0, max: 1 },
    quadra: '',
    lote: '',
  });

  const [quadrasDisponiveis, setQuadrasDisponiveis] = useState([]);
  const [lotesDisponiveis, setLotesDisponiveis] = useState([]);

  const QuadraVazia = () => {
    return (
      filtros.quadra === null ||
      filtros.quadra === undefined ||
      filtros.quadra === ''
    );
  };

  const SelecionouLote = () => {
    return (
      filtros.lote !== '' && filtros.lote !== null && filtros.lote !== undefined
    );
  };

  // Define os valores iniciais e os ranges
  useEffect(() => {
    setAtivosFiltrados([]);
    if (ativosOriginais && ativosOriginais.length > 0) {
      // Filtra somente imóveis com status = 0 e valores válidos
      const filtrados = ativosOriginais.filter(
        ativo =>
          ativo.status === 0 && // Garantir que o status é 0
          ativo.valor_vista > 0 &&
          ativo.valor_inicial_parcela_programada > 0 &&
          ativo.area > 0
      );

      setQuadrasDisponiveis([...new Set(filtrados.map(ativo => ativo.quadra))]);
      setLotesDisponiveis([...new Set(filtrados.map(ativo => ativo.lote))]);

      setAtivosFiltrados(filtrados);

      if (filtrados.length > 0) {
        const novoRange = {
          valor_vista: {
            min: Math.min(...filtrados.map(a => a.valor_vista)),
            max: Math.max(...filtrados.map(a => a.valor_vista)),
          },
          valor_inicial_parcela_programada: {
            min: Math.min(
              ...filtrados.map(a => a.valor_inicial_parcela_programada)
            ),
            max: Math.max(
              ...filtrados.map(a => a.valor_inicial_parcela_programada)
            ),
          },
          area: {
            min: Math.min(...filtrados.map(a => a.area)),
            max: Math.max(...filtrados.map(a => a.area)),
          },
        };
        setRanges(novoRange);
        setFiltros(novoRange);
      }
    }
  }, [ativosOriginais]);

  // Atualiza os filtros e filtra os itens
  useEffect(() => {
    const ativosAtualizados = ativosOriginais.filter(ativo => {
      const dentroValorVista =
        ativo.valor_vista >= filtros.valor_vista.min &&
        ativo.valor_vista <= filtros.valor_vista.max;
      const dentroParcelas =
        ativo.valor_inicial_parcela_programada >=
          filtros.valor_inicial_parcela_programada.min &&
        ativo.valor_inicial_parcela_programada <=
          filtros.valor_inicial_parcela_programada.max;
      const dentroArea =
        ativo.area >= filtros.area.min && ativo.area <= filtros.area.max;
      const quadra = QuadraVazia() ? true : filtros.quadra === ativo.quadra;
      const lote = !SelecionouLote() ? true : filtros.lote === ativo.lote;
      return (
        ativo.status === 0 &&
        dentroValorVista &&
        dentroParcelas &&
        dentroArea &&
        quadra &&
        lote
      ); // Garante que o status continua sendo 0
    });

    setQuadrasDisponiveis([
      ...new Set(ativosAtualizados.map(ativo => ativo.quadra)),
    ]);
    setLotesDisponiveis([
      ...new Set(ativosAtualizados.map(ativo => ativo.lote)),
    ]);

    setAtivosFiltrados(ativosAtualizados);
  }, [filtros, ativosOriginais]);

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Filtrar Lotes</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container className="px-5">
          <Row>
            <Col className="text-center">
              <div className="slider-section">
                <h5 className="mb-4">Valor do Lote</h5>
                <InputRange
                  maxValue={ranges.valor_vista.max}
                  minValue={ranges.valor_vista.min}
                  step={10000}
                  value={filtros.valor_vista}
                  formatLabel={value => `R$ ${value.toLocaleString()}`}
                  onChange={value => {
                    const valorTratado = {
                      min: Math.max(ranges.valor_vista.min, value.min),
                      max: Math.min(ranges.valor_vista.max, value.max),
                    };
                    setFiltros(prev => ({
                      ...prev,
                      valor_vista: valorTratado,
                    }));
                  }}
                />
              </div>
            </Col>
          </Row>
          <hr />
          <Row>
            <Col className="text-center">
              <div className="slider-section">
                <h5 className="mb-4">Parcelas Programadas</h5>
                <InputRange
                  maxValue={ranges.valor_inicial_parcela_programada.max}
                  minValue={ranges.valor_inicial_parcela_programada.min}
                  value={filtros.valor_inicial_parcela_programada}
                  formatLabel={value => `R$ ${value.toLocaleString()}`}
                  onChange={value => {
                    const valorTratado = {
                      min: Math.max(
                        ranges.valor_inicial_parcela_programada.min,
                        value.min
                      ),
                      max: Math.min(
                        ranges.valor_inicial_parcela_programada.max,
                        value.max
                      ),
                    };
                    setFiltros(prev => ({
                      ...prev,
                      valor_inicial_parcela_programada: valorTratado,
                    }));
                  }}
                />
              </div>
            </Col>
          </Row>
          <hr />
          <Row>
            <Col className="text-center">
              <div className="slider-section">
                <h5 className="mb-4">Tamanho do Terreno</h5>
                <InputRange
                  maxValue={ranges.area.max}
                  minValue={ranges.area.min}
                  value={filtros.area}
                  formatLabel={value => `${value} m²`}
                  onChange={value => {
                    const valorTratado = {
                      min: Math.max(ranges.area.min, value.min),
                      max: Math.min(ranges.area.max, value.max),
                    };
                    setFiltros(prev => ({ ...prev, area: valorTratado }));
                  }}
                />
              </div>
            </Col>
          </Row>
          <hr />
          <h5 className="mb-4 text-center">Pesquisa por Quadra e Lote</h5>
          <Row>
            <Col md={6}>
              <label>Quadra</label>
              <select
                className="form-control"
                value={filtros.quadra || ''}
                onChange={e => {
                  const novaQuadra = e.target.value;
                  setFiltros(prev => ({
                    ...prev,
                    quadra: novaQuadra,
                  }));
                }}
              >
                <option value="">Todas as quadras</option>
                {quadrasDisponiveis.map(quadra => (
                  <option key={quadra} value={quadra}>
                    {quadra}
                  </option>
                ))}
              </select>
            </Col>
            <Col md={6}>
              <label>Lote</label>
              <select
                className="form-control"
                value={filtros.lote || ''}
                onChange={e => {
                  const novoLote = e.target.value;
                  setFiltros(prev => ({
                    ...prev,
                    lote: novoLote,
                  }));
                }}
              >
                <option value="">Todos os lotes</option>
                {lotesDisponiveis.map(lote => (
                  <option key={lote} value={lote}>
                    {lote}
                  </option>
                ))}
              </select>
            </Col>
          </Row>
          <hr />
          <Row>
            <Col className="text-center">
              <div className="mt-3">
                <h6>Total de Itens Encontrados: {ativosFiltrados.length}</h6>
              </div>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex justify-content-between w-100">
          <Button variant="secondary" onClick={() => setFiltros(ranges)}>
            Limpar Filtros
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              onApplyFilters(ativosFiltrados, QuadraVazia() ? false : true);
              onHide();
            }}
          >
            Aplicar Filtros
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalFiltro;
